export default __webpack_public_path__ + "static/media/ChevronDown.0246e858.svg";